<div class="form-check">
  <label>
    <input
      type="checkbox"
      class="form-check-input"
      (change)="onConsentChange()"
      [checked]="consentGiven"
      [name]="consentTemplate.id"
      [disabled]="isRequired(consentTemplate?.id)"
      />
      <span class="form-check-label cx-be-bold">
        @if (consentTemplate?.name) {
          {{ consentTemplate?.name }}
          <br/>
        }
      </span>
      <span class="form-check-label">
        <p [innerHTML]="consentTemplate?.description | cxSupplementHashAnchors"></p>

      </span>
    </label>
  </div>
